export default "__VITE_ASSET__B45TVOm___"